import {FAILURE, PENDING, SUCCESS} from '../../constants'
import {searchEntityFieldTypes as searchEntityFieldTypesApi} from '../../../services/entities'

export async function searchEntityFieldTypes(dispatch, entity_id, params = {}) {
  try {
    dispatch({type: PENDING})
    let response = await searchEntityFieldTypesApi(entity_id, params)
    dispatch({type: SUCCESS, payload: response})
    return response
  } catch (e) {
    console.log(`Search Entity Field Types Failed`)
    dispatch({type: FAILURE, payload: e})
    return Promise.reject(e)
  }
}
